import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
// import { notificationSound } from '../../../assets/sounds';
import { toast } from "react-toastify";
import VendorSidebar from "../../../components/Vendor/sidebar";
import VendorNavbar from "../../../components/Vendor/navbar";

const VendorDashboard = () => {
  const [currentPage, setCurrentPage] = useState("dashboard");
  const navigate = useNavigate();

  return (
    <div>
      <div className="col-md-12 col-xl-12 container-fluid dashboardcontainer  ">
        <div className="row flex-nowrap ">
          <VendorSidebar
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
          <div className="col dashboardright d-flex justify-content-center ">
            <div className="dashboardright-width">
              <VendorNavbar currentPage={currentPage} />
              <div className="dashboardright-scroll">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="custom-toast">
        <ToastContainer limit={1} />
      </div> */}
      </div>
    </div>
  );
};
export default VendorDashboard;
